import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Radio from '../../../shared/components/AriaRadio/Radio';
import createUniqueId from '../../../shared/helpers/createUniqueId';
import { RadioContext } from '../../../shared/components/AriaRadio/RadioGroup';


const ProductSort = function ProductSortComponent({ productSort, sortHandler, pendingRequest }) {
  const state = useContext(RadioContext);
  const didMount = useRef(false);
  const idMap = useRef({});

  useEffect(() => {
    productSort.options.forEach((option) => {
      idMap.current[createUniqueId(option.id)] = option.url;
    });
  }, []);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }

    sortHandler(idMap.current[state.selectedValue]);
  }, [state.selectedValue]);

  return (
    <>
      { productSort &&
        productSort.options && !!productSort.options.length && productSort.options.length > 0 &&
          productSort.options.map((option) => {
            const uniqueId = createUniqueId(option.id);

            const field = {
              id: uniqueId,
              selected: state.selectedValue === uniqueId,
              label: option.displayName,
              value: option.url,
            };

            return (
              <div className="results-grid__radio" key={uniqueId}>
                <Radio
                  key={uniqueId}
                  field={field}
                  fieldName={option.displayName}
                  theme="filter"
                  blocked={pendingRequest && !field.selected}
                />
              </div>
            );
          })
      }
    </>
  );
};

ProductSort.propTypes = {
  sortHandler: PropTypes.func.isRequired,
  productSort: PropTypes.shape({
    activeProductSortId: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      displayName: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  pendingRequest: PropTypes.bool,
};

ProductSort.defaultProps = {
  pendingRequest: false,
};

export default ProductSort;
